import React from 'react';
import {
    Grid,
    Typography,
    Button,
} from '@mui/material';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import PhoneInput from 'react-phone-input-2';


const labelStyle = {
    marginBottom: '4px',
    fontWeight: 500,
    color: '#1A1A1A',
};

const inputStyle = {
    height: '46px',
    backgroundColor: '#fff',
    fontSize: '13px',
};

const PersonalInfo = ({ onCancel, onSave }) => {
    return (
        <form>
            <Grid container spacing={2}>
                {/* First Name */}
                <Grid item size={{ xs: 12, md: 6, sm: 6 }}>
                    <Typography variant="body2" sx={labelStyle}>
                        First Name <span style={{ color: 'red' }}>*</span>
                    </Typography>
                    <TextField
                        fullWidth
                        placeholder="Enter your first name"
                        variant="outlined"
                        InputProps={{ sx: inputStyle }}
                    />
                </Grid>

                {/* Last Name */}
                <Grid item size={{ xs: 12, md: 6, sm: 6 }}>
                    <Typography variant="body2" sx={labelStyle}>
                        Last Name <span style={{ color: 'red' }}>*</span>
                    </Typography>
                    <TextField
                        fullWidth
                        placeholder="Enter your last name"
                        variant="outlined"
                        InputProps={{ sx: inputStyle }}
                    />
                </Grid>

                {/* Date of Birth */}
                <Grid item size={{ xs: 12, md: 6, sm: 6 }}>
                    <Typography variant="body2" sx={labelStyle}>
                        Date of Birth
                    </Typography>
                    <TextField
                        fullWidth
                        placeholder="10-May-1999"
                        defaultValue="10-May-1999"
                        variant="outlined"
                        InputProps={{ sx: inputStyle }}
                    />
                </Grid>

                {/* Phone Number with country code and flag */}
                <Grid item size={{ xs: 12, md: 6, sm: 6 }}>
                    <Typography variant="body2" sx={labelStyle}>
                        Phone Number
                    </Typography>
                    <PhoneInput
                        country={'in'}
                        inputStyle={{
                            width: '100%',
                            height: '46px',
                            fontSize: '13px',
                            borderRadius: '4px',
                        }}
                        containerStyle={{ width: '100%' }}
                        placeholder="Enter your phone number"
                        enableSearch
                    />
                </Grid>

                {/* Home Address */}
                <Grid item size={{ xs: 12, md: 6, sm: 6 }}>
                    <Typography variant="body2" sx={labelStyle}>
                        Home Address
                    </Typography>
                    <TextField
                        fullWidth
                        placeholder="Enter your address"
                        defaultValue="45 Oak Street, Apt 3C, New York, NY 10001, USA"
                        variant="outlined"
                        InputProps={{ sx: inputStyle }}
                    />
                </Grid>

                {/* Email Address */}
                <Grid item size={{ xs: 12, md: 6, sm: 6 }}>
                    <Typography variant="body2" sx={labelStyle}>
                        Email Address
                    </Typography>
                    <TextField
                        fullWidth
                        placeholder="Enter your email"
                        defaultValue="john.doe@email.com"
                        variant="outlined"
                        InputProps={{
                            sx: inputStyle,
                            startAdornment: (
                                <InputAdornment position="start">
                                    <MailOutlineIcon />
                                </InputAdornment>
                            ),
                        }}
                    />
                </Grid>

                {/* Action Buttons */}
                <Grid item size={{ xs: 12, md: 12 }} sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 2 }}>
                    <Button
                        variant="outlined"
                        color="inherit"
                        sx={{
                            fontSize: '14px',
                            borderRadius: '50px',
                            background: '#fff',
                            border: '1px solid #9095A1',
                            color: '#9095A1',
                        }}
                        onClick={onCancel}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        sx={{
                            fontSize: '14px',
                            borderRadius: '50px',
                            background: '#0076FE',
                            border: '1px solid #0076FE',
                            color: '#fff',
                        }}
                        onClick={onSave}
                    >
                        Save & Update
                    </Button>
                </Grid>
            </Grid>
        </form>
    );
};

export default PersonalInfo;
